import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProductRegistrationContext } from '@/product-registration/context';

// import components
import {
  ProductRegistrationSearchLazy,
  ProductRegistrationSelectLazy,
  ProductRegistrationUserDetailLazy,
  ProductRegistrationDetailLazy,
  ProductRegistrationConfirmationLazy,
} from '@/product-registration/pages';
import Title from '@/components/atoms/Title';
import Timeline from '@/components/organisms/Timeline';

const ProductRegistrationApp = () => {
  const { t } = useTranslation();
  const [
    { currentStep, steps, wrapperClass },
  ] = useProductRegistrationContext();

  return (
    <div className={`dln-prodReg ${wrapperClass} dln-page`}>
      <div className='dln-wrapper'>
        <div className='dln-prodReg__head'>
          {currentStep === 4 ? (
            <Title
              text={t(
                'productRegistration:product.registration.confirmation.page.title',
              )}
            />
          ) : (
            <>
              <Title
                text={t('productRegistration:product.registration.page.title')}
              />
              {currentStep === 1 && (
                <p className='dln-prodReg__paragraph'>
                  {t('productRegistration:product.registration.page.subtitle')}
                </p>
              )}
              <Timeline steps={steps} t={t} currentStep={currentStep} />
            </>
          )}
        </div>
        <Switch>
          <Route
            path='/:lang?/product-registration/search'
            component={ProductRegistrationSearchLazy}
          />
          <Route
            path='/:lang?/product-registration/select'
            component={ProductRegistrationSelectLazy}
          />
          <Route
            path='/:lang?/product-registration/user-detail'
            component={ProductRegistrationUserDetailLazy}
          />
          <Route
            path='/:lang?/product-registration/detail'
            component={ProductRegistrationDetailLazy}
          />
          <Route
            path='/:lang?/product-registration/confirmation'
            component={ProductRegistrationConfirmationLazy}
          />
        </Switch>
      </div>
    </div>
  );
};

export default ProductRegistrationApp;
